import {
  REQUEST_CONTEXT_COOKIE_NAME,
  readRequestContextCookie,
} from '@highereducation/request-context';

export interface EventRequestContextFacts {
  readonly experiment: string;
  readonly bot: string;
}

function readCookieValue(
  cookieHeader: string,
  name: string,
): string | undefined {
  const prefix = `${name}=`;
  for (const part of cookieHeader.split(';')) {
    const trimmed = part.trim();
    if (trimmed.startsWith(prefix)) {
      return trimmed.slice(prefix.length);
    }
  }
  return undefined;
}

/**
 * Experiment and bot from the `rv_ctx` snapshot. The visit id is not read.
 * A missing cookie is unknown. This does not map partner headers.
 */
export function readEventRequestContext(
  cookieHeader?: string,
): EventRequestContextFacts {
  const source =
    cookieHeader ?? (typeof document === 'undefined' ? '' : document.cookie);
  const raw = readCookieValue(source, REQUEST_CONTEXT_COOKIE_NAME);
  let decoded = raw;
  if (raw) {
    try {
      decoded = decodeURIComponent(raw);
    } catch {
      decoded = raw;
    }
  }
  const snapshot = readRequestContextCookie(decoded);
  return {
    experiment: snapshot.experiment,
    bot: snapshot.bot,
  };
}
